/**
 * Whether this browser has agreed to cookies.
 *
 * Three states, and the difference between two of them matters: `null` means
 * nobody has been asked yet, which is not the same as having said no. Only
 * `granted` ever loads anything.
 *
 * A refusal expires. Asking again in a week is a question; asking on every
 * load is asking until somebody gives in, which is the thing that makes a
 * consent worthless.
 */
const KEY = 'bluedot.consent';

export const GRANTED = 'granted';
export const DENIED = 'denied';
export const DENIED_TTL_MS = 7 * 24 * 60 * 60 * 1000;

const stored = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

const put = (value, at) => {
  try { localStorage.setItem(KEY, JSON.stringify({ value, at })); } catch { /* the choice still holds for this page */ }
};

export function readConsent(now = Date.now()) {
  const raw = stored();
  if (!raw) return null;

  // Before this was dated it was the bare word. Stamp it on the way past, so
  // an old refusal starts its week now rather than never ending.
  if (raw === GRANTED || raw === DENIED) {
    put(raw, now);
    return raw;
  }

  let parsed;
  try { parsed = JSON.parse(raw); } catch { return null; }
  if (parsed?.value === GRANTED) return GRANTED;
  if (parsed?.value !== DENIED) return null;
  if (!Number.isFinite(parsed.at)) return null;
  return now - parsed.at < DENIED_TTL_MS ? DENIED : null;
}

export function writeConsent(value, now = Date.now()) {
  put(value, now);
}
